import React from "react";
import MVMIcon from "../../Common/MVMIcon";
import ParticipantAvatar from "./ParticipantAvatar";
import ParticipantStats from "./ParticipantStats";
const ParticipantDetails = (props) => {
    const { participant, distanceUnit, maxRank, totalMissionDistance, isTeamList = false } = props;
    3;
    const renderName = () => {
        if (participant.type === "user") {
            return (React.createElement("p", { className: "weight-600 mb-0 text-center" },
                participant.firstName,
                " ",
                React.createElement("span", { className: "weight-300" }, participant.lastName)));
        }
        return (React.createElement("p", { className: "weight-600 mb-0 text-center" }, participant.teamName));
    };
    const renderFinFlag = () => {
        if (participant.completedTime) {
            return (React.createElement("div", { className: "leaderboard-participant-details-finflag" },
                React.createElement("p", { className: "mb-0 tiny weight-600 white fst-italic text-center" }, "FIN")));
        }
        return null;
    };
    const renderCompletedFlag = () => {
        if (participant.completedTime) {
            return (React.createElement("div", { className: "leaderboard-participant-details-completed" },
                React.createElement("p", { className: "tiny mb-0" },
                    "COMPLETED IN:",
                    " ",
                    React.createElement("span", { className: "weight-500" }, participant.completedTime))));
        }
        return null;
    };
    const renderExerciseTypes = () => {
        if (participant.exerciseTypes.length > 0) {
            return (React.createElement("div", { className: "d-flex justify-content-center mt-2" }, participant.exerciseTypes.map((type, index) => (React.createElement("div", { key: index, className: "leaderboard-participant-details-exercise" },
                React.createElement(MVMIcon, { width: 20, height: 20, icon: type.alias }),
                React.createElement("p", { className: "ms-1 mb-0 weight-600 tiny" },
                    type.distance,
                    distanceUnit))))));
        }
        return null;
    };
    return (React.createElement("div", { className: "leaderboard-participant-details p-2 pt-1" },
        renderName(),
        React.createElement("div", { className: "d-flex" },
            React.createElement(ParticipantAvatar, { type: participant.type, id: participant.id, firstName: participant.firstName, image: participant.image, countryCode: participant.countryCode }),
            React.createElement("div", { className: "flex-fill" },
                React.createElement(ParticipantStats, { isTeamList: isTeamList, distance: participant.distance, distanceUnit: distanceUnit, completionPct: participant.completionPct }),
                React.createElement("p", { className: "small grey mb-0 leaderboard-participant-details-distance" },
                    "of",
                    " ",
                    React.createElement("span", { className: "weight-500" },
                        totalMissionDistance,
                        distanceUnit)),
                renderCompletedFlag()),
            React.createElement("div", null,
                React.createElement("div", { className: "leaderboard-participant-details-rank text-center" },
                    React.createElement("p", { className: "mb-0 border-bottom border-2 tiny dark-grey weight-600 px-1" }, "RANK"),
                    React.createElement("p", { className: "black weight-700 px-2 pt-1 mb-0" }, participant.rank),
                    React.createElement("p", { className: "mb-0 grey tiny" },
                        "of ",
                        React.createElement("span", { className: "weight-600" }, maxRank))),
                renderFinFlag())),
        renderExerciseTypes()));
};
export default ParticipantDetails;
